<template>
    <div class="bkk-destory">

        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreateRecordsDialog">新增
            </el-button>
        </div>

        <div class="bkk-destory-list">
            <el-table class="bkk-destory-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="destroyBatch" label="销毁批次"></el-table-column>
                <el-table-column prop="destroyUrl" label="销毁地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="currentDestroyAmount" label="本次销毁数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalDestroyAmount" label="累计销毁数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="initAmount" label="初始化总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="currentAmount" label="现存总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="lockAmount" label="锁仓总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="currentCirculation" label="当前流通量" show-overflow-tooltip></el-table-column>
                <el-table-column label="销毁时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.destoryTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="updateRecordDialog(scope.row)">修改</el-button>
                        <el-button type="danger" @click="deleteRecord(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="120px" :model="addData" :rules="dataRules" ref="currForm">
                <el-form-item prop="destroyBatch" label="销毁批次">
                    <el-input placeholder="请输入销毁批次" v-model="addData.destroyBatch"></el-input>
                </el-form-item>
                <el-form-item prop="destroyUrl" label="销毁地址">
                    <el-input placeholder="请输入销毁地址" v-model="addData.destroyUrl"></el-input>
                </el-form-item>
                <el-form-item prop="currentDestroyAmount" label="本次销毁数量">
                    <el-input placeholder="请输入本次销毁数量" v-model="addData.currentDestroyAmount"></el-input>
                </el-form-item>
                <el-form-item prop="totalDestroyAmount" label="累计销毁数量">
                    <el-input placeholder="请输入累计销毁数量" v-model="addData.totalDestroyAmount"></el-input>
                </el-form-item>
                <el-form-item prop="initAmount" label="初始化总量">
                    <el-input placeholder="请输入初始化总量" v-model="addData.initAmount"></el-input>
                </el-form-item>
                <el-form-item prop="currentAmount" label="现存总量">
                    <el-input placeholder="请输入现存总量" v-model="addData.currentAmount"></el-input>
                </el-form-item>
                <el-form-item prop="lockAmount" label="锁仓总量">
                    <el-input placeholder="请输入锁仓总量" v-model="addData.lockAmount"></el-input>
                </el-form-item>
                <el-form-item prop="currentCirculation" label="当前流通量">
                    <el-input placeholder="请输入当前流通量" v-model="addData.currentCirculation"></el-input>
                </el-form-item>
                <el-form-item prop="destoryTime" label="销毁时间">
                    <el-date-picker
                            v-model="addData.destoryTime"
                            type="datetime"
                            value-format="timestamp"
                            placeholder="请选择销毁时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addBkkDestroyRecord">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'BkkDestroy',
        data() {
            return {
                dataList: [], //数据列表
                dialogVisible: false, //对话框是否显示
                dialogTitle: "", //对话框标题
                loading: false,
                addData: {
                    id: "",
                    destroyBatch: "",
                    destroyUrl: "",
                    currentDestroyAmount: "",
                    totalDestroyAmount: "",
                    initAmount: "",
                    currentAmount: "",
                    lockAmount: "",
                    currentCirculation: "",
                    destoryTime: ""
                },
                dataRules: {
                    "destroyBatch": [{required: true, message: "请输入销毁批次"}],
                    "destroyUrl": [{required: true, message: "请输入销毁地址"}],
                    "currentDestroyAmount": [{required: true, message: "请输入本次销毁数量"}],
                    "totalDestroyAmount": [{required: true, message: "请输入累计销毁数量"}],
                    "initAmount": [{required: true, message: "请输入初始化总量"}],
                    "currentAmount": [{required: true, message: "请输入现存总量"}],
                    "lockAmount": [{required: true, message: "请输入锁仓总量"}],
                    "currentCirculation": [{required: true, message: "请输入当前流通量"}],
                    "destoryTime": [{required: true, message: "请输入销毁时间"}]
                },
            };
        },
        methods: {
            getBkkDestroyRecordList() {
                api.getBkkDestroyRecordList().then(({data}) => {
                    this.dataList = data;
                });
            },
            addBkkDestroyRecord() {
                this.$refs["currForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.addBkkDestroyRecord(this.addData).then(({data}) => {
                            this.$message.success('保存成功!');
                            this.getBkkDestroyRecordList();
                            this.dialogVisible = false;
                            this.loading = false;
                        });
                    }
                });
            },
            openCreateRecordsDialog() {
                this.dialogTitle = "增加";
                this.dialogVisible = true;
            },
            updateRecordDialog(row) {
                this.dialogTitle = "修改";
                this.addData = {
                    id: row.id,
                    destroyBatch: row.destroyBatch,
                    destroyUrl: row.destroyUrl,
                    currentDestroyAmount: row.currentDestroyAmount,
                    totalDestroyAmount: row.totalDestroyAmount,
                    initAmount: row.initAmount,
                    currentAmount: row.currentAmount,
                    lockAmount: row.lockAmount,
                    currentCirculation: row.currentCirculation,
                    destoryTime: row.destoryTime
                }
                this.dialogVisible = true;
            },
            deleteRecord(row) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteBkkDestroyRecord({id: row.id}).then(({data}) => {
                        this.$message.success('删除成功!');
                        this.getBkkDestroyRecordList();
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.dialogTitle = "";
                this.loading = false;
                this.addData = {
                    id: "",
                    destroyBatch: "",
                    destroyUrl: "",
                    currentDestroyAmount: "",
                    totalDestroyAmount: "",
                    initAmount: "",
                    currentAmount: "",
                    lockAmount: "",
                    currentCirculation: "",
                    destoryTime: ""
                }
            }
        },
        created() {
            this.getBkkDestroyRecordList();
        }
    };
</script>

<style lang="less" scoped>
    .bkk-destory {
        .preview-opration {
            float: right;
        }

        .bkk-destory-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .bkk-destory-table {
                margin-top: 30px;
            }
        }
    }
</style>

